import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../../global/env';
import { AuditLogReportRequest, EnrollmentReportItem, ThresholdChangeReportItem } from '../../model/auditlogreports';

const fetchThresholdChanges = async (request: AuditLogReportRequest): Promise<ThresholdChangeReportItem[]> => {
  const url = Config.auditReportsBaseURL + 'ThresholdChanges';
  const { data } = await axios.post(url, request);
  //@ts-ignore
  return data.map(item => new ThresholdChangeReportItem(item));
}

const useThresholdChanges = (request: AuditLogReportRequest) => {
  return useQuery<ThresholdChangeReportItem[], Error>(['ThresholdChange', request], () => fetchThresholdChanges(request));
}

export default useThresholdChanges;